import Vue from 'vue'
import Vuex from 'vuex'
import { get, post, patch } from '../libs/axios.js'
import permission from './permission.js'
import router from '@/router'
import common from '@/libs/util.js'
import user from './modules/user'
import qcc from './modules/qcc'
import getter from './getters.js'
import { Message } from 'view-design'
Vue.use(Vuex)

const state = {
  isCollapsed: false,
  platform: 'lawyer',
  menuList: [],
  currentUser: {
    username: '',
    UserRefreshToken: '',
    UserToken: ''
  },
  tagMenuArr: [],
  tagMenuPathArr: [],
  toBeAllocatedCase: 0,
  wechatInfo: {
    code: '',
    state: ''
  },
  hasInfo: false
}

const mutations = {
  toggleCollapsed(state, isCollapsed) {
    state.isCollapsed = isCollapsed
  },
  changeMenu(state, menuList) {
    state.menuList = menuList
  },
  openTagMenu(state, obj, name) {
    console.log('&&&&&&&：', obj, name)
    state.tagMenuArr = obj.tagMenuArr
    state.tagMenuPathArr = obj.tagMenuPathArr
  },
  setWeChatInfo(state, info) {
    state.wechatInfo = info
  },
  setToBeAllocatedCase(state, num) {
    state.toBeAllocatedCase = num
  },
  setHasInfo(state, bool) {
    state.hasInfo = bool
  }
}
const getters = {
  ...getter,
  toggleCollapsed(state) {
    return state.isCollapsed
  },
  wechatInfo(state) {
    return state.wechatInfo
  },
  changeMenu(state) {
    return state.menuList
  },
  openTagMenu(state) {
    return state
  },
  getToBeAllocatedCase: state => state.toBeAllocatedCase,
  tagMenuPathArr: state => state.tagMenuPathArr
}
const actions = {
  setWeChatInfo({ commit }, info) {
    commit('setWeChatInfo', info)
  },
  // 获取待审核律师数量
  getToBeAllocatedCaseCount({ commit }) {
    const url = '/business/cases/wait-distribution/count/lawyer'
    get(url).then(res => {
      if (res.code == 0) {
        commit('setToBeAllocatedCase', res.data)
      }
    })
  },
  async getAccessToken({ commit }, info) {
    const unionId = await common.getUnionId(info.code, info.state)
    const url = '/authentication/auth/loginWechat'
    const ajaxData = {
      unionId: unionId,
      providerId: 'wechat',
      grantType: 'password'
    }
    post(url, ajaxData).then(res => {
      if (res.code == 0) {
        window.localStorage.setItem('token', res.data.accessToken)
        window.localStorage.setItem('refreshToken', res.data.refreshToken)
        window.localStorage.setItem('expiryTime', new Date().getTime())
        window.localStorage.setItem('account', JSON.stringify(res.data.additionalInformation.account))
        window.localStorage.setItem('pauseState', res.data.additionalInformation.currentUser && res.data.additionalInformation.currentUser.pauseState) // 用户状态
        router.push({ path: '/' })
      } else if (res.code == 10005) {
        router.push({ path: '/login', query: { unionId: unionId }})
      } else {
        Message.error(res.message)
      }
    })
  }
}

var vuexStore = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: { permission: permission, user, qcc }
})

export default vuexStore



// WEBPACK FOOTER //
// ./src/store/index.js